import type { ReactNode } from 'react';

type Tone = 'info' | 'warning' | 'success' | 'danger';

const toneClass: Record<Tone, string> = {
  info: 'bg-sky-100 text-navy-900 border-sky-200',
  warning: 'bg-amber-50 text-amber-900 border-amber-200',
  success: 'bg-emerald-50 text-emerald-900 border-emerald-200',
  danger: 'bg-red-50 text-red-900 border-red-200',
};

export function StatusBanner({
  tone = 'info',
  title,
  children,
  action,
}: {
  tone?: Tone;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={`rounded-xl border px-4 py-3 sm:py-3.5 ${toneClass[tone]}`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <div className="font-semibold text-sm">{title}</div>
          {children && <div className="text-sm opacity-90 mt-0.5">{children}</div>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </div>
  );
}
